export const VERSION_APP = '0.0.2';

export const ROURES = {
  MOVIE: '/movie/:slug',
};
